import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Body from '../content/body';
import Sidebar from '../content/sidebar';
import Header from '../content/header';

const PostHero = props => {
  const { posts, advertorial } = props;
  const post = get(posts, '[0]', {});

  return [
    <div className="post__hero">
      <Header {...props} tags={post.tags} post={post} isLongPost={true} />
    </div>,
    <div className="post post--hero">
      <div className="post__main">
        <Body {...props} post={post} isLongPost={true} hasNewsletter={true} />
      </div>
      <Sidebar
        {...props}
        post={post}
        fullPageAdvertorial={advertorial}
        isLongPost={true}
      />
    </div>
  ];
};

PostHero.propTypes = {
  posts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  advertorial: PropTypes.bool.isRequired
};

export default PostHero;
